// extracted by mini-css-extract-plugin
export default {"title":"room_price_breakdown_title__mX6jC"};